<template>
    <FKBreadCrumb :page="$t('page.request_support')">
        <FKBreadCrumbItem :page="$t('page.profile')" to="/profile"/>
    </FKBreadCrumb>
    <RequestSupportForm/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from '@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue';
import RequestSupportForm from '@/components/FK/Profile/RequestSupportForm.vue';

export default defineComponent({
    name: "RequestSupportPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        RequestSupportForm
    }
})
</script>